module.exports = __webpack_public_path__ + "static/media/code.7b70a76d.png";